"use client";

import React, { FC, PropsWithChildren, useEffect } from "react";
import { SpinnerIcon } from "@/common/components/icons/SpinnerIcon";
import { setDisabledFeatureFlags } from "@/common/store/config/slice";
import { useAppDispatch } from "@/common/store/redux";
import { useDisabledFeatureFlags } from "@/services/swagger/gen";
export const FeatureFlagProvider: FC<PropsWithChildren> = props => {
  const {
    children
  } = props;
  const {
    data,
    isLoading
  } = useDisabledFeatureFlags();
  const dispatch = useAppDispatch();
  useEffect(() => {
    const disabledFeatureFlags = new Map();
    if (data) {
      data.data.forEach(featureFlag => {
        disabledFeatureFlags.set(featureFlag.value, true);
      });
    }
    dispatch(setDisabledFeatureFlags(disabledFeatureFlags));
  }, [data, dispatch]);
  if (isLoading) {
    return <div className="flex h-screen items-center">
        <SpinnerIcon className="mx-auto size-5 animate-spin" />
      </div>;
  }
  return <>{children}</>;
};